<template>
    <div class="modal fade" :id="id" tabindex="-1" aria-hidden="true" :data-bs-backdrop="backdrop">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header d-block">
                    <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
                </div>
                <div class="modal-body">
                    <p v-html="message"></p>
                </div>
                <div class="modal-footer">
                    <button @click="$emit('confirm')" data-bs-dismiss="modal" class="default-btn transition">
                        {{ $t('cta.ok') }}
                    </button>

                </div>
                <!-- <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button> -->
            </div>
        </div>
    </div>
</template>
  
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        title: String,
        message: String,
        id: {
            type: String,
            required: true
        },
        dismissible: {
            type: Boolean,
            default: true
        },
    },
    name: "AlertModal",
    computed: {
        backdrop(): String {
            return this.dismissible === false ? 'static': 'true';
        }
    }
});
</script>